module.exports = __webpack_public_path__ + "img/nocodequestions.16df7577.svg";